/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Field_Secrets_Hint_EditInputs */



/**
* | output |
* | --- |
* | "Leave a value empty to keep what is stored. Removing a row removes that secret." |
*
* @param {Partner_Connectors_Field_Secrets_Hint_EditInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_field_secrets_hint_edit = /** @type {((inputs?: Partner_Connectors_Field_Secrets_Hint_EditInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Field_Secrets_Hint_EditInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein leerer Wert behält den gespeicherten. Eine entfernte Zeile entfernt dieses Secret.")
	return /** @type {LocalizedString} */ ("Leave a value empty to keep what is stored. Removing a row removes that secret.")
});